import { memo } from 'react';
import styled from 'styled-components';

import type { CommonRadioBlockProps } from '@wecasa/common/src/types/components';

import Card from '../card/card';
import Radio, { type RadioProps } from '../radio/radio';
import RadioBlockTitle from './radio-block-title';

const Content = styled.div`
  padding: 20px;
`;

const Label = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const StyledRadio = styled(Radio)`
  margin-right: 0;
`;

export type RadioBlockProps = CommonRadioBlockProps & Omit<RadioProps, 'checked'>;

const RadioBlock = ({
  alwaysShowContent = false,
  checked,
  children,
  id,
  name,
  onChange,
  title,
  value,
  className,
}: RadioBlockProps) => (
  <Card className={className}>
    <Content>
      <Label htmlFor={id}>
        {typeof title === 'string' ? <RadioBlockTitle title={title} /> : title}
        <StyledRadio checked={checked} id={id} name={name} onChange={onChange} value={value} />
      </Label>
      {(checked || alwaysShowContent) && <div>{children}</div>}
    </Content>
  </Card>
);

export default memo(RadioBlock);
